import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { AuthGuard } from './services/auth/auth-guard';
import { RouteUrls } from './shared/enums/route-urls.enum';
import {
  ABOUT_PAGE,
  CONTACT_PAGE,
  FAQ_PAGE,
  PRIVACY_PAGE,
  TERMS_PAGE,
} from './site/content/content-pages';
import { SiteLayoutComponent } from './site/site-layout/site-layout.component';

const loadContentPage = () =>
  import('./site/content-page/content-page.component').then((c) => c.ContentPageComponent);

const loadNotFoundPage = () =>
  import('./site/not-found/not-found.component').then((c) => c.NotFoundComponent);

export const routes: Routes = [
  {
    path: '',
    component: SiteLayoutComponent,
    data: { siteLayout: true },
    children: [
      {
        path: RouteUrls.Home,
        pathMatch: 'full',
        title: 'Give Santa | A Personalized Christmas Story',
        loadComponent: () =>
          import('./site/home-page/home-page.component').then((c) => c.HomePageComponent),
      },
      {
        path: RouteUrls.Faq,
        title: 'FAQ | Give Santa',
        data: {
          page: FAQ_PAGE,
          description: 'Everything you need to know about creating your personalized GiveSanta movie.',
        },
        loadComponent: loadContentPage,
      },
      {
        path: RouteUrls.About,
        title: 'About | GiveSanta',
        data: {
          page: ABOUT_PAGE,
          description:
            'GiveSanta turns the little things that make someone special into a personalized cinematic Santa adventure made just for them.',
        },
        loadComponent: loadContentPage,
      },
      {
        path: RouteUrls.Contact,
        title: 'Contact | Give Santa',
        data: {
          page: CONTACT_PAGE,
          description:
            'Have a question about GiveSanta, your order, or your personalized movie? We’re here to help.',
        },
        loadComponent: loadContentPage,
      },
      {
        path: RouteUrls.Privacy,
        title: 'Privacy Policy | Give Santa',
        data: {
          page: PRIVACY_PAGE,
          description: 'Privacy information for Give Santa personalized Christmas stories.',
        },
        loadComponent: loadContentPage,
      },
      {
        path: RouteUrls.Terms,
        title: 'Terms & Conditions | Give Santa',
        data: {
          page: TERMS_PAGE,
          description: 'Terms for Give Santa personalized Christmas stories.',
        },
        loadComponent: loadContentPage,
      },
      {
        path: RouteUrls.PageNotFound,
        title: 'Page not found | Give Santa',
        loadComponent: loadNotFoundPage,
      },
    ],
  },
  {
    path: RouteUrls.VideoGenerator,
    loadComponent: () =>
      import('./containers/video-generator-form-v2/video-generator-form-v2.component').then(
        (c) => c.VideoGeneratorFormV2Component,
      ),
  },
  {
    path: RouteUrls.Account,
    loadComponent: () =>
      import('./containers/account/account.component').then((c) => c.AccountComponent),
    canActivate: [AuthGuard],
  },
  {
    path: RouteUrls.Basket,
    loadComponent: () =>
      import('./containers/basket/basket-summary-v2/basket-summary-v2.component').then(
        (c) => c.BasketSummaryV2Component,
      ),
  },
  {
    path: RouteUrls.Order,
    loadComponent: () =>
      import('./containers/sections/order-summary/order-summary.component').then(
        (c) => c.OrderSummaryComponent,
      ),
  },
  {
    path: RouteUrls.OrderWithId,
    loadComponent: () =>
      import('./containers/sections/order-summary/order-summary.component').then(
        (c) => c.OrderSummaryComponent,
      ),
  },
  {
    path: RouteUrls.OrderPlaced,
    loadComponent: () =>
      import('./containers/order-placed/order-placed.component').then(
        (c) => c.OrderPlacedComponent,
      ),
  },
  { path: 'about-us', redirectTo: RouteUrls.About },
  { path: 'contact-us', redirectTo: RouteUrls.Contact },
  { path: 'terms-of-service', redirectTo: RouteUrls.Terms },
  { path: 'basket-old', redirectTo: RouteUrls.Basket },
  {
    path: 'how-it-works',
    redirectTo: () => inject(Router).createUrlTree(['/'], { fragment: 'how' }),
  },
  { path: 'pricing', redirectTo: RouteUrls.Home },
  { path: 'feedback', redirectTo: RouteUrls.Home },
  {
    path: '**',
    component: SiteLayoutComponent,
    data: { siteLayout: true },
    children: [
      {
        path: '',
        title: 'Page not found | Give Santa',
        loadComponent: loadNotFoundPage,
      },
    ],
  },
];
